import { OfferFragment } from '@occc/graphql';
import { makeCreateEmailRequiredConstraintOperation } from '@occc-app/offerHelpers/operations/constraints';
import { makeDeleteOperation } from '@occc-app/offerHelpers/operations/makeDeleteOperation';
import { DirtyFieldsType, Operation } from '@occc-app/offerHelpers/types';
import { isFieldDirty } from '@occc-app/offerHelpers/utils';
import { constraintHelper } from '@occc-app/offerHelpers/utils/constraintHelper';
import { OfferType } from '@occc-app/routes/Offer/types';

import { EmailRequiredFormValues } from './email-required-constraint.types';

export const getEmailRequiredConstraint = (offer: OfferFragment | undefined) => {
  return offer?.constraints.find(constraintHelper.isEmailRequired);
};

export const getEmailRequiredInitialValues = (
  offer: OfferFragment,
): EmailRequiredFormValues['emailRequiredConstraint'] => {
  const emailRequiredConstraint = getEmailRequiredConstraint(offer);

  return {
    isEnabled: !!emailRequiredConstraint,
  };
};

export const getEmailRequiredConstraintOperations = (
  offerId: string,
  offer: OfferFragment | undefined,
  values: EmailRequiredFormValues,
  dirtyFields: DirtyFieldsType,
  offerType: OfferType,
): Operation[] => {
  const operations: Operation[] = [];
  const existingConstraint = getEmailRequiredConstraint(offer);
  const isExternalFulfillment = offerType === OfferType.ExternalFulfillment;
  const shouldBeEnabled = values.emailRequiredConstraint.isEnabled;
  const isDirty = isFieldDirty<EmailRequiredFormValues>(
    dirtyFields,
    'emailRequiredConstraint.isEnabled',
  );

  // Force remove constraint for unsupported offer types
  if (existingConstraint && !isExternalFulfillment) {
    operations.push(makeDeleteOperation('constraintDelete', existingConstraint.id));
    return operations;
  }

  // Skip if field hasn't changed
  if (!isDirty) {
    return operations;
  }

  // Remove constraint if it should be disabled
  if (existingConstraint && !shouldBeEnabled) {
    operations.push(makeDeleteOperation('constraintDelete', existingConstraint.id));
  }

  // Create constraint if it should be enabled
  if (!existingConstraint && shouldBeEnabled && isExternalFulfillment) {
    operations.push(makeCreateEmailRequiredConstraintOperation(offerId));
  }

  return operations;
};
